export const INPUT_FIELD_PADDING_Y = '!py-[1.1rem]';
